import { useCallback, useMemo } from "react";
import { toast } from "react-toastify";
import IGeoCoordinate from "../interfaces/IGeoCoordinate";
import ParcelApiService from "../services/parcelApiService";
import useNavigateToInsights from "./useNavigateToInsights";

export default function useNavigateToMunicipalityInsights(): (municipality: string, centerPoint: IGeoCoordinate) => Promise<void> {
    const navigateToInsights = useNavigateToInsights();
    const parcelApiService = useMemo(() => new ParcelApiService(), []);

    return useCallback(async (municipality: string, centerPoint: IGeoCoordinate) => {
        const shape = await parcelApiService.getMunicipalityShapeFeature(centerPoint, municipality).catch(() => null);
        if (!shape) {
            toast.warning(`The municipality shape for ${municipality} is not found`);
            return;
        }

        navigateToInsights(shape);
    }, []);
}
